
export type UserPageResponseSort = {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
};
